<template>
        <div class="row justify-content-center">
            <div class="col-lg-5 col-md-7">
                <div class="card bg-secondary shadow border-0">
                    <div class="card-body px-lg-5 py-lg-5">
                        <div class="text-center text-muted mb-4">
                            <small>Bitte geben Sie Ihr neues Passwort ein</small>
                            <base-alert v-if="alert.message" :type="alert.type">{{alert.message}}</base-alert>
                        </div>
                        <form @submit="handleSubmit">
                            <base-input class="input-group-alternative"
                                        placeholder="Passwort"
                                        type="password"
                                        addon-left-icon="ni ni-lock-circle-open"
                                        :valid="validPasswordReset"
                                        v-model="model.plainPassword"
                                        :disabled="isLoading">
                            </base-input>
                            <base-input class="input-group-alternative"
                                        placeholder="Passwort bestätigen"
                                        type="password"
                                        addon-left-icon="ni ni-lock-circle-open"
                                        v-model="plainPassword2"
                                        :disabled="isLoading"
                            >
                            </base-input>

                            <div class="text-center">
                                <button class="btn my-4 btn-primary" :disabled="!validPasswordReset || isLoading" type="submit">Passwort ändern</button>
                            </div>
                        </form>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-6 text-right">
                        <a href="https://socialguard.app" class="text-light" target="_blank"><small>Create new account</small></a>
                    </div>
                </div>
            </div>
        </div>
</template>
<script>


  export default {
    name: 'ForgotPassword',
    data() {
      return {
          model: {
              token: '',
              plainPassword: ''
          },
          plainPassword2: '',
          submitted: false,
          isLoading: false
        }
    },
      computed: {
          alert () {
              return this.$store.state.alert
          },
          validPasswordReset() {
              return this.validPassword(this.model.plainPassword) && this.model.plainPassword === this.plainPassword2;
          }
      },
      created () {
        this.model.token = this.$route.params.token;
      },
      methods: {
          handleSubmit (e) {
              e.preventDefault();
              return new Promise(() => {
                  this.submitted = true;
                  let senddata = this.model;
                  this.isLoading = true;
                  const requestOptions = {
                      method: 'POST',
                      headers: { 'Content-Type': 'application/json' },
                      body: JSON.stringify(senddata)
                  };

                  fetch(process.env.VUE_APP_API_SERVER + `/resetpw`, requestOptions)
                      .then(this.handleResponse)
                      .then(response => {
                          this.$store.dispatch('alert/success',response);
                          this.isLoading = false;
                          this.$router.push('/login');},
                          error => {
                            this.$store.dispatch('alert/error',error);
                            this.isLoading = false;
                      });
              });

          }
      }
  }
</script>
<style>
</style>
